import { render, staticRenderFns } from "./UserServiceDialog.vue?vue&type=template&id=613b8bd2&scoped=true"
import script from "./UserServiceDialog.vue?vue&type=script&lang=ts"
export * from "./UserServiceDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserServiceDialog.vue?vue&type=style&index=0&id=613b8bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b8bd2",
  null
  
)

export default component.exports